// ================================================
// DK Selling Plan Selector
// ── Radio-selectie → hidden selling_plan input
// ── Actieve kaart highlighten
// ── Variant-wissel: plan-allocations herberekenen
// ================================================

(function () {
  'use strict';

  function initSelector(root) {
    var sps = root.querySelector('.dk-sps');
    if (!sps || sps._dkSpsInit) return;
    sps._dkSpsInit = true;

    var hiddenInput = root.querySelector('input[name="selling_plan"]');
    var radios = sps.querySelectorAll('.dk-sps__radio');
    var options = sps.querySelectorAll('.dk-sps__option');

    // ── Selectie bijwerken ──
    function updateSelection(radio) {
      // hidden input
      if (hiddenInput) {
        if (radio.value) {
          hiddenInput.value = radio.value;
          hiddenInput.disabled = false;
        } else {
          // eenmalige aankoop: geen selling_plan meesturen
          hiddenInput.value = '';
          hiddenInput.disabled = true;
        }
      }

      // actieve klasse op kaart
      options.forEach(function (opt) { opt.classList.remove('dk-sps__option--active'); });
      var label = radio.closest('.dk-sps__option');
      if (label) label.classList.add('dk-sps__option--active');
    }

    // initialiseer met de reeds gecheckte radio
    radios.forEach(function (radio) {
      if (radio.checked) updateSelection(radio);
      radio.addEventListener('change', function () {
        if (this.checked) updateSelection(this);
      });
    });

    // klik op de label zelf (hele kaart is klikbaar)
    options.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        // niet nogmaals triggeren als de radio al gecheckt is
        var radio = opt.querySelector('.dk-sps__radio');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  // ── Zoek de form en init ──
  function initAll() {
    document.querySelectorAll('[data-product-form="main"], [data-type="add-to-cart-form"]').forEach(function (form) {
      initSelector(form);
    });
    // fallback: zoek ook buiten de form (sommige themes)
    document.querySelectorAll('.dk-sps').forEach(function (sps) {
      if (!sps._dkSpsInit) {
        var form = sps.closest('form');
        if (form) initSelector(form);
      }
    });
  }

  // ── Variant-wissel: allocations herladen via AJAX ──
  // Wanneer de variant wijzigt (bv. optie-keuze), moeten prijzen
  // in de kaarten herladen worden via het productJSON endpoint.
  function handleVariantChange(productId, variantId) {
    if (!productId || !variantId) return;
    fetch('/products/' + productId + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var variant = (data.variants || []).find(function (v) { return v.id === parseInt(variantId, 10); });
        if (!variant || !variant.selling_plan_allocations) return;

        variant.selling_plan_allocations.forEach(function (alloc) {
          var card = document.querySelector('.dk-sps__option[data-plan-id="' + alloc.selling_plan_id + '"]');
          if (!card) return;

          var priceEl = card.querySelector('.dk-sps__price');
          var compareEl = card.querySelector('.dk-sps__compare');
          var savingsEl = card.querySelector('.dk-sps__savings');

          if (priceEl) priceEl.textContent = formatMoney(alloc.per_delivery_price);
          if (compareEl) {
            if (alloc.compare_at_price > alloc.per_delivery_price) {
              compareEl.textContent = formatMoney(alloc.compare_at_price);
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }
          if (savingsEl) {
            var saving = alloc.compare_at_price - alloc.per_delivery_price;
            if (saving > 0) {
              savingsEl.querySelector
                ? (savingsEl.firstChild.textContent = 'Bespaar ' + formatMoney(saving) + ' ')
                : null;
              savingsEl.style.display = '';
            } else {
              savingsEl.style.display = 'none';
            }
          }
        });

        // Eenmalige aankoop prijs updaten
        var onetimeCard = document.querySelector('.dk-sps__option--onetime');
        if (onetimeCard) {
          var onetimePrice = onetimeCard.querySelector('.dk-sps__price');
          if (onetimePrice) onetimePrice.textContent = formatMoney(variant.price);
        }
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, ',-');
    return '\u20AC' + euros;
  }

  // ── Luister naar variant-wijzigingen ──
  document.addEventListener('variant:change', function (e) {
    if (e.detail && e.detail.variant) {
      var productId = e.detail.product && e.detail.product.id;
      if (!productId) {
        var sps = document.querySelector('.dk-sps');
        if (sps) productId = sps.dataset.productId;
      }
      handleVariantChange(productId, e.detail.variant.id);
    }
  });

  // Shopify-standaard event
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input && input.name === 'id' && input.form) {
      var sps = input.form.querySelector('.dk-sps');
      if (sps) handleVariantChange(sps.dataset.productId, input.value);
    }
  });

  // ── Bootstrap ──
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
